import React,{useState} from 'react';
import './App.css';
import {Routes,Route} from 'react-router-dom';
import {Account,Dashboard} from './views';


function App() {
  const [userHasChangePassword,setUserHasChangePassword] = useState<boolean>(false);
  return (
    <div className="App">
       <Routes>
        {/* <Route index element={<Account data={userHasChangePassword} onChange={setUserHasChangePassword}/>}/> */}
        <Route path="dashboard/*" element={<Dashboard data={userHasChangePassword} onChange={setUserHasChangePassword} />}/>
        <Route path="/*" element={<Account data={userHasChangePassword} onChange={setUserHasChangePassword} />} />
       </Routes>
    </div>
  );
}

export default App;
